// 인증 관련 API 함수들
import apiClient, { API_BASE_URL } from "@services/api/apiClient.jsx";
import axios from "axios";
import { useAuthStore } from "@/store/useAuthStore.jsx";

const authApi = {
    // 사용자 정보 가져오기
    getCurrentUser: async () => {
        try {
            // Zustand store에서 사용자 정보 가져오기
            const { user } = useAuthStore.getState();

            if (!user || !user.id) {
                // store에 없으면 /auth/me API 호출
                const meResponse = await apiClient.get('/auth/me');
                if (!meResponse.data?.success || !meResponse.data?.data) {
                    throw new Error('사용자 정보를 가져올 수 없습니다.');
                }
                const userId = meResponse.data.data.id;
                // store 업데이트
                useAuthStore.getState().login(meResponse.data.data);

                // 상세 정보 가져오기
                const response = await apiClient.get(`/auth/${userId}`);
                return response.data;
            }

            // store에 있으면 바로 사용
            const response = await apiClient.get(`/auth/${user.id}`);
            return response.data;
        } catch (error) {
            console.error('사용자 정보 가져오기 실패:', error);
            throw error;
        }
    },

    // 승인 대기 상태의 사용자 추가 정보 제출
    submitPendingApprovalInfo: async (additionalInfo, refreshToken = null) => {
        try {
            // Zustand store에서 사용자 ID 가져오기
            const { user } = useAuthStore.getState();

            let userId = user?.id;
            if (!userId) {
                // store에 없으면 /auth/me API 호출
                const meResponse = await apiClient.get('/auth/me');
                if (!meResponse.data?.success || !meResponse.data?.data) {
                    throw new Error('사용자 정보를 가져올 수 없습니다.');
                }
                userId = meResponse.data.data.id;
                // store 업데이트
                useAuthStore.getState().login(meResponse.data.data);
            }

            // 헤더에 리프레시 토큰 추가
            const headers = {};
            if (refreshToken) {
                headers['X-Refresh-Token'] = refreshToken;
            }

            // PUT 메소드로 사용자 정보 업데이트
            const response = await apiClient.put(`/auth/${userId}`, additionalInfo, { headers });
            return response.data;
        } catch (error) {
            console.error('사용자 정보 업데이트 실패:', error);
            throw error;
        }
    },

    // at 갱신 (백엔드에서 자동 처리되므로 직접 호출할 필요 없음)
    refreshToken: async () => {
        try {
            // 쿠키는 withCredentials로 자동 전송됨
            // 백엔드에서 HttpOnly 쿠키를 직접 읽어 처리
            const response = await apiClient.post('/auth/refresh');
            return response.data;
        } catch (error) {
            console.error('토큰 갱신 실패:', error);
            throw error;
        }
    },

    // 로그아웃
    logout: async () => {
        try {
            const response = await apiClient.post('/auth/logout');
            return response.data;
        } catch (error) {
            console.error('로그아웃 API 호출 실패:', error);
            throw error;
        }
    },

    /**
     * 회원가입 API
     * OAuth2 인증 후 신규 회원이 추가 정보를 입력하여 회원가입 완료
     * @param {Object} signupData - 회원가입 데이터
     * @param {string} signupData.signupToken - 회원가입 토큰 (JWT)
     * @param {string} signupData.name - 이름
     * @param {string} signupData.phone - 연락처
     * @param {Array} signupData.userRoles - 역할-지점 배열
     */
    signup: async (signupData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/signup`, signupData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('회원가입 API 호출 실패:', error);
            throw error;
        }
    }
};

export default authApi;